var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.resultData.data, function(item, index) {
        return _c(
          "div",
          { key: `search-result-item-${index}`, staticClass: "mb-3" },
          [
            _c(
              "callout",
              {
                ref: "callout",
                refInFor: true,
                attrs: {
                  controlled: true,
                  disabled: _vm.showDetails(item.serviceName),
                  "has-toggle": true,
                  opened: item.isOpen
                },
                on: {
                  "click:open": function($event) {
                    return _vm.openDetails(
                      { item, index },
                      _vm.PANELS.ADDITIONAL_INFO
                    )
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "edition",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "p-2" }, [
                            _c("div", { staticClass: "bg-white rounded p-3" }, [
                              _c("div", { staticClass: "mb-3" }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _vm.selectedOption == _vm.PANELS.CLAIM
                                        ? _c("claim-card", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.RECEIVED
                                        ? _c("received-card", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              ),
                                              "claim-by-pin": _vm.isClaimByPin(
                                                item
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption ==
                                      _vm.PANELS.SINGLE_RECEIVED
                                        ? _c("single-received-card", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              ),
                                              title: _vm.singleReceivedLabel(
                                                item.status
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.DELIVER
                                        ? _c("deliver-card", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.ARCHIVE
                                        ? _c("archive-card", {
                                            attrs: { id: item.id },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.CANCEL
                                        ? _c("cancel-card", {
                                            attrs: { id: item.id },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption ==
                                      _vm.PANELS.MANAGEMENT
                                        ? _c("card-management", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.DOCUMENTS
                                        ? _c("document-card", {
                                            attrs: { id: item.id },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption ==
                                      _vm.PANELS.DELIVEREDCSEE
                                        ? _c("delivered-csee", {
                                            attrs: {
                                              id: item.id,
                                              "bank-request-date": new Date(
                                                item.bankRequestDate
                                              )
                                            },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption ==
                                      _vm.PANELS.ADDITIONAL_INFO
                                        ? _c("additional-info", {
                                            attrs: { item: item }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption ==
                                      _vm.PANELS.BANKREQUEST
                                        ? _c("bank-request", {
                                            attrs: { id: item.id },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.selectedOption == _vm.PANELS.RETURN
                                        ? _c("return-card", {
                                            attrs: { id: item.id },
                                            on: {
                                              "on-cancel": function($event) {
                                                return _vm.toggleOpen(index)
                                              },
                                              "on-saved": function($event) {
                                                return _vm.doSearch(index)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 border-right pr-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "mt-3 text-center" },
                        [
                          _c("custom-balloon", {
                            staticClass: "w-md-90 w-100 m-0",
                            attrs: {
                              "background-color": ` bg-${_vm.getColorStatus(
                                item.status
                              )}`,
                              text: item.status.name
                            }
                          }),
                          _c("div", { staticClass: "mt-3 ml-3 text-left" }, [
                            item.generatedByClaimType ==
                              _vm.ByClaimType.Tarjeta &&
                            item.status.id !=
                              _vm.CardManagementStatus.SolicitadaBanco
                              ? _c("div", { staticClass: "data-label" }, [
                                  _c("i", {
                                    staticClass: "far fa-credit-card mr-3"
                                  }),
                                  _vm._v(" Tarjeta ")
                                ])
                              : _vm._e(),
                            item.generatedByClaimType == _vm.ByClaimType.PIN
                              ? _c("div", { staticClass: "data-label" }, [
                                  _c("i", {
                                    staticClass: "fas fa-calculator mr-3"
                                  }),
                                  _vm._v(" PIN ")
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-md-10 py-2 px-4" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "data-label" }, [
                          _vm._v("Estudiante:")
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(
                            " " +
                              _vm._s(item.numSIE) +
                              "-" +
                              _vm._s(_vm.getStudentFullName(item)) +
                              " "
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "col-sm pl-md-5" }, [
                        _c("div", { staticClass: "data-label" }, [
                          _vm._v("Fecha de Creación:")
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm._f("date")(item.createdDate)))
                        ])
                      ]),
                      _c("div", { staticClass: "col-sm col-md-3" }, [
                        _c("div", { staticClass: "data-label" }, [
                          _vm._v("Número de Secuencia:")
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(item.sequenceRegionNumber))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-sm d-flex justify-content-end" },
                        [
                          _c("drop-down", {
                            staticClass: "mr-3",
                            attrs: {
                              "data-item": { item, index },
                              items: _vm.actionItems(item)
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            )
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: {
              data: _vm.resultData.pagination,
              "page-size": 15,
              "show-text": true
            },
            on: { "pagination-go-page": _vm.onPageChange }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }